import { useCallback, useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Admin panel data fetcher.
 * Centralises licenses / stats / notif log polling.
 * Extracted from AdminPanel.jsx on 29/05/2026 (code review refactor).
 */
export default function useAdminPanelData(admin) {
  const [licenses, setLicenses] = useState([]);
  const [stats, setStats] = useState(null);
  const [notifLog, setNotifLog] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLicenses = useCallback(async () => {
    if (!admin) return;
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/licenses`, {
        headers: { 'Authorization': `Bearer ${admin.token}` },
      });
      if (res.ok) setLicenses(await res.json());
    } catch (err) { console.warn('fetchLicenses error:', err.message); }
    setLoading(false);
  }, [admin]);

  const fetchStats = useCallback(async () => {
    if (!admin) return;
    try {
      const res = await fetch(`${API}/api/licenses/stats`, {
        headers: { 'Authorization': `Bearer ${admin.token}` },
      });
      if (res.ok) setStats(await res.json());
    } catch (err) { console.warn('fetchStats error:', err.message); }
  }, [admin]);

  const fetchNotifLog = useCallback(async () => {
    if (!admin) return;
    try {
      const res = await fetch(`${API}/api/notifications/log`, {
        headers: { 'Authorization': `Bearer ${admin.token}` },
      });
      if (res.ok) setNotifLog(await res.json());
    } catch (err) { console.warn('fetchNotifLog error:', err.message); }
  }, [admin]);

  useEffect(() => {
    fetchLicenses();
    fetchStats();
    fetchNotifLog();
  }, [fetchLicenses, fetchStats, fetchNotifLog]);

  return { licenses, stats, notifLog, loading, fetchLicenses, fetchStats, fetchNotifLog };
}
